module.exports = __webpack_public_path__ + "img/footer-logo.497ad456.png";